import {
  FETCH_LEAVE_TYPES_REQUEST, FETCH_LEAVE_TYPES_SUCCESS, FETCH_LEAVE_TYPES_FAIL,
  FETCH_USER_LEAVE_TYPES_REQUEST, FETCH_USER_LEAVE_TYPES_SUCCESS, FETCH_USER_LEAVE_TYPES_FAIL,
  CLEAR_USER_LEAVE_TYPES,
} from "../../constants/Leave/LeaveTypeConstants";
import LeaveTypeService from "../../service/Leave/LeaveTypeService";
import { extractRows } from "../../service/Leave/leaveHelpers";

const errMsg = (error, fallback) => error.response?.data?.message || error.message || fallback;

export const fetchLeaveTypes = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_LEAVE_TYPES_REQUEST });
    const body = await LeaveTypeService.getAll();
    const data = extractRows(body)
      .map((item) => ({
        id: String(item.HLT_TYPE_ID ?? ""),
        code: String(item.HLT_CODE ?? "").toUpperCase(),
        name: item.HLT_NAME ?? "",
        paid: item.HLT_IS_PAID,
        status: item.HLT_ACTIVE_STATUS,
        isPaid: ["Y", "YES", "TRUE", "1"].includes(String(item.HLT_IS_PAID ?? "").trim().toUpperCase()),
        isActive: ["A", "ACTIVE", "Y", "TRUE", "1"].includes(String(item.HLT_ACTIVE_STATUS ?? "").trim().toUpperCase()),
        displayOrder: Number(item.HLT_DISPLAY_ORDER) || 0,
      }))
      .filter((t) => t.id);
    dispatch({ type: FETCH_LEAVE_TYPES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: FETCH_LEAVE_TYPES_FAIL, payload: errMsg(error, "Failed to fetch leave types") });
  }
};

export const fetchUserLeaveTypes = (serviceNo) => async (dispatch, getState) => {
  try {
    dispatch({ type: FETCH_USER_LEAVE_TYPES_REQUEST });
    const body = await LeaveTypeService.getByUser(serviceNo);
    const master = getState().leaveTypes?.data || [];

    const seen = new Set();
    const data = [];
    extractRows(body).forEach((item) => {
      const code = String(item.HLT_CODE ?? item.HLA_LEAVE_TYPE_CODE ?? "").toUpperCase();
      let id = item.HLT_TYPE_ID ?? item.HLA_LEAVE_TYPE_ID ?? null;
      if (id == null && code) id = master.find((t) => t.code === code)?.id ?? null;
      if (id == null) return;
      id = String(id);
      if (seen.has(id)) return; // the same type appears once per year
      seen.add(id);
      data.push({
        id, code,
        name: item.HLT_NAME ?? item.HLA_LEAVE_TYPE_NAME ?? master.find((t) => t.id === id)?.name ?? `Leave Type ${id}`,
      });
    });
    dispatch({ type: FETCH_USER_LEAVE_TYPES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: FETCH_USER_LEAVE_TYPES_FAIL, payload: errMsg(error, "Failed to fetch leave types") });
  }
};

export const clearUserLeaveTypes = () => ({ type: CLEAR_USER_LEAVE_TYPES });